// extracted by mini-css-extract-plugin
module.exports = {"companyRateCodeBlock":"CompanyRateCodeBlock_companyRateCodeBlock__H9y5W"};